export default (el) => {
    let secondLvl = document.querySelectorAll('.nav-aside .second-level-container.triggered'),
        nav = document.querySelector('.nav-aside'),
        btnClose = document.querySelector('.close-nav-aside');
    nav.classList.add('triggered');
    secondLvl.forEach(second => {
        second.classList.remove('triggered');
    });
    el.parentElement.querySelector('.second-level-container').classList.add('triggered');
    btnClose.classList.add('triggered');
}